(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["chasen-rating-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('chasen-rating-link')) {
    customElements.define('chasen-rating-link',class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller=new AbortController();
        this.sync=this.sync.bind(this);
        for(const event of ['chasen:reviews-updated','shopify:section:load','shopify:section:unload','DOMContentLoaded'])document.addEventListener(event,this.sync,{signal:this.controller.signal});
        this.querySelector('a').addEventListener('click',event=>{
          const section=this.source();
          const target=section?.querySelector('[data-review-heading]');
          if(!target)return;
          event.preventDefault();
          target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
          target.focus({preventScroll:true});
          history.replaceState(null,'','#'+target.id);
        },{signal:this.controller.signal});
        this.sync();
      }
      disconnectedCallback(){this.controller?.abort();}
      source(){return [...document.querySelectorAll('chasen-reviews')].find(el=>el.dataset.product===this.dataset.product);}
      sync(){
        const section=this.source();
        if(!section)return;
        const total=section.dataset.demo==='true'?0:Number(section.dataset.reviewCount)||0;
        const count=section.dataset.demo==='true'?0:Number(section.dataset.ratedCount)||0;
        const average=Number(section.dataset.ratingAverage)||0;
        const stars=this.querySelector('.cr-rating-link__stars');
        stars.hidden=!count;
        this.querySelector('[data-star-fill]').style.width=Math.min(100,average/5*100)+'%';
        const reviews=this.dataset.reviewsLabel.replace('__COUNT__',total);
        const ratings=this.dataset.ratingsLabel.replace('__COUNT__',count);
        const text=count?this.dataset.summaryLabel.replace('__AVERAGE__',average.toFixed(1)).replace('__COUNT__',total):total?reviews+' · '+this.dataset.noRating:this.dataset.first;
        this.querySelector('[data-rating-text]').textContent=text;
        const target=section.querySelector('[data-review-heading]');
        if(target)this.querySelector('a').setAttribute('href','#'+target.id);
        this.setAttribute('data-ready','true');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
